export const AVATAR_COLORS = ['#344050', '#344050', '#344050', '#344050']